import type { User } from '../types';

export const FREE_OVERLAP_HORIZON_DAYS = 14;
export const FREE_ROSTER_IMPORTS_PER_MONTH = 1;

export function isPremiumActive(user: User): boolean {
  if (user.tier !== 'premium') return false;
  if (user.tierExpiresAt) {
    return new Date(user.tierExpiresAt) > new Date();
  }
  return true;
}

export function isOverlapGatedByPremium(overlapDate: string, user: User): boolean {
  if (isPremiumActive(user)) return false;
  const now = new Date();
  const horizon = new Date(now);
  horizon.setDate(horizon.getDate() + FREE_OVERLAP_HORIZON_DAYS);
  return new Date(overlapDate) > horizon;
}

const IMPORT_COUNT_PREFIX = 'rostfound_imports_';

function currentMonthKey(): string {
  const now = new Date();
  return `${IMPORT_COUNT_PREFIX}${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}

export function getRosterImportCount(): number {
  try {
    return parseInt(localStorage.getItem(currentMonthKey()) || '0', 10);
  } catch {
    return 0;
  }
}

export function incrementRosterImportCount(): void {
  const key = currentMonthKey();
  const count = getRosterImportCount();
  localStorage.setItem(key, String(count + 1));
}

export function canImportRoster(user: User): boolean {
  if (isPremiumActive(user)) return true;
  return getRosterImportCount() < FREE_ROSTER_IMPORTS_PER_MONTH;
}
